import { render, staticRenderFns } from "./ColorSwitcher.vue?vue&type=template&id=371872be&scoped=true&"
import script from "./ColorSwitcher.vue?vue&type=script&lang=js&"
export * from "./ColorSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwitcher.vue?vue&type=style&index=0&id=371872be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371872be",
  null
  
)

export default component.exports